import { PageRoutes } from '../../../../app/pages/domain/constants/PageRoutes';

export function getNewsItemUrl(slug: string) {
	return `${PageRoutes.News}/item/${slug}`;
}
